import { OperatorEmptyState } from '@/shared/operator'

export interface ListEmptyStateProps {
  /** Override message; defaults to the App flat-list copy. */
  message?: string
  /** Uppercase mono kicker above the status line. */
  kicker?: string
}

const DEFAULT_MESSAGE = 'No records found'

export function ListEmptyState({
  message = DEFAULT_MESSAGE,
  kicker = 'List',
}: ListEmptyStateProps) {
  return <OperatorEmptyState kicker={kicker}>{message}</OperatorEmptyState>
}
